import createIcon from '../../createIcon';

/**
 * @component @name FormatAlignLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTVIM1YxN0gxNVYxNVpNMTUgN0gzVjlIMTVWN1pNMyAxM0gyMVYxMUgzVjEzWk0zIDIxSDIxVjE5SDNWMjFaTTMgM1Y1SDIxVjNIM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatAlignLeft = createIcon('FormatAlignLeft', [
  [
    'path',
    {
      d: 'M15 15H3V17H15V15ZM15 7H3V9H15V7ZM3 13H21V11H3V13ZM3 21H21V19H3V21ZM3 3V5H21V3H3Z',
      key: '1k86n0',
    },
  ],
]);

export default FormatAlignLeft;
